import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateEvent($companyId: ID!, $attributes: EventAttributes!) {
    createEvent(companyId: $companyId, attributes: $attributes) {
      event {
        id
        ...CreatedEvent
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedEvent on Event {
    id
    description
    details
    dateOut
    dateStart
    dateEnd
    dateReturn
    warehouse { id name address }
    venue { id name address }
    client { id clientType { name color } }
    state
  }
`
